import { trans } from '@lingoda/i18n';
import { useIsLearningTeams } from '@lingoda/learning-teams';
import { LingodaLogo } from '@lingoda/logotype';
import { goTo, studentBookingPath } from '@lingoda/router';
import { Box, Button, Typography, colorsPalette, muiFocusVisibleOutlineMixin } from '@lingoda/ui';
import { SearchIcon16 } from '@lingoda/ui/icons/SearchIcon';
import { styled } from '@lingoda/ui/theme';

export const BookClassMobileCTA = () => {
    const isLearningTeams = useIsLearningTeams();

    return isLearningTeams ? null : (
        <ButtonStyled
            onClick={() => goTo(studentBookingPath())}
            fullWidth
            labelFullWidth
            variant={'outlined'}
            color={'inherit'}
            focusRipple={false}
        >
            <Container>
                <TextContainer>
                    <LingodaLogo aria-hidden isIcon height={20} />
                    <Typography variant={'subtitle2'}>
                        {trans('navigation.user.book-classes', {}, 'public-common')}
                    </Typography>
                </TextContainer>
                <SearchIconStyled />
            </Container>
        </ButtonStyled>
    );
};

const ButtonStyled = styled(Button)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    border: `1px solid ${colorsPalette.blackAlpha[20]}`,
    borderRadius: theme.spacing(3),
    height: theme.spacing(5),
    padding: `${theme.spacing(1)} ${theme.spacing(1.5)}`,
    color: colorsPalette.blackSolid[100],

    '@media (hover: hover)': {
        '&:hover': {
            backgroundColor: colorsPalette.blackAlpha[4],
        },
    },

    ...muiFocusVisibleOutlineMixin(theme),
}));

const Container = styled(Box)(() => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
}));

const TextContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    gap: theme.spacing(1),
    marginRight: 'auto',
}));

const SearchIconStyled = styled(SearchIcon16)(() => ({
    color: colorsPalette.blackAlpha[70],
}));
